export const normalizeFieldKey = (value) => String(value ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Mirrors the backend default used when an event has no publicSearchFields configured.
export const DEFAULT_PUBLIC_SEARCH_FIELDS = ['Name', 'Contact', 'Email'];

// Stored formData keys don't always match schema labels exactly (renames, spacing, punctuation).
export function findFormDataKey(formData = {}, label) {
  if (Object.prototype.hasOwnProperty.call(formData, label)) return label;
  const target = normalizeFieldKey(label);
  return Object.keys(formData).find((key) => normalizeFieldKey(key) === target) || label;
}

// Top-level schema fields plus the sub-fields of whichever option is currently selected,
// mirroring what the registration form showed (sub-field values are stored flat in formData).
export function getApplicableFields(schema = [], formData = {}) {
  const fields = [];
  const walk = (list) => (list || []).forEach((field) => {
    if (!field?.label) return;
    fields.push(field);
    const value = formData[findFormDataKey(formData, field.label)];
    if (value == null || typeof value === 'object') return;
    const selected = (field.optionsWithPricing || []).find(
      (option) => normalizeFieldKey(option?.label) === normalizeFieldKey(value)
    );
    if (selected?.subFields?.length) walk(selected.subFields);
  });
  walk(schema);
  return fields;
}

// formData keys that no applicable field covers, e.g. nested objects or answers to options no longer selected.
export function getExtraFormDataKeys(formData = {}, fields = []) {
  const covered = new Set(fields.map((field) => normalizeFieldKey(field.label)));
  return Object.keys(formData).filter((key) => !covered.has(normalizeFieldKey(key)));
}

// [{ label, value }] for each configured label that has a displayable value in formData.
export function pickDisplayFields(formData = {}, labels = []) {
  return (labels || [])
    .map((label) => ({ label, value: formData?.[findFormDataKey(formData || {}, label)] }))
    .filter(({ value }) => value != null && typeof value !== 'object' && String(value).trim() !== '')
    .map(({ label, value }) => ({ label, value: String(value) }));
}
